import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { sanitizeExtraAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const fetchSmartlinkDataErrorEventPayload = (
	error: unknown,
	commonAttributes: commonAttributesType,
): AnalyticsEventPayload => {
	const { extraAttributes, source } = commonAttributes;

	return {
		action: 'failed',
		actionSubject: 'aiSourceFetchSmartlinkData',
		source,
		eventType: 'track',
		attributes: {
			...sanitizeExtraAttributes(extraAttributes),
			errorName: error instanceof Object && 'name' in error ? error.name : '',
			errorMessage: error instanceof Object && 'message' in error ? error.message : '',
			errorStack:
				error instanceof Object && 'stack' in error && typeof error.stack === 'string'
					? error.stack?.split('\n').at(1)
					: '',
		},
	};
};
